import { reject } from "q"

function RegexMatch(text, regex) {
    return new Promise((resolve, reject) => {
        if (regex.test(text.trim())) {
            resolve()
        } else {
            reject('Invalid input')
        }
    })
}

function MinCharLength(text, minLength) {
    return new Promise((resolve, reject) => {
        if (text.length < minLength) {
            reject(`Minimum ${minLength} characters required`)
        } else {
            resolve()
        }
    })
}

function MaxCharLength(text, maxLength) {
    return new Promise((resolve, reject) => {
        if (text.trim().length <= maxLength) {
            resolve()
        } else {
            reject(`Exceeded the maximum limit of ${maxLength} characters`)
        }
    })
}

function SupportedFilesCheck(files, formats) {
    return new Promise((resolve, reject) => {
        let result = Array.from(files).filter(file => {
            return !formats.includes(file.type)
        })
        if (result.length > 0) reject({ files: result, message: 'attachment_file_types' })
        else resolve()
    })
}

function sizeCalculation(files, maxSize) {
    return new Promise((resolve, reject) => {
        let size = 0
        Array.from(files).forEach(file => {
            size += file.size
        })
        let sizeInMBs = size / 1048576
        if (sizeInMBs > maxSize) {
            // reject(`File size exceeds the limit of ${maxSize} MB`)
            reject(`attachment_file_size`)
        } else {
            resolve()
        }
    })
}

function checkBlankArray(files) {
    return new Promise((resolve, reject) => {
        if (files.length === 0) {
            reject('Attachments required')
        } else {
            resolve()
        }
    })
}

export const onOTPrequestValidation = async (inputs, setErrors) => {
    return Promise.all([
        await MaxCharLength(inputs.first_name || '', 40).then(() => true).catch((err) => (setErrors((s) => ({ ...s, first_name: err })))),
        await MaxCharLength(inputs.last_name || '', 40).then(() => true).catch((err) => (setErrors((s) => ({ ...s, last_name: err })))),
        await RegexMatch(inputs.first_name || '', /^[a-zA-Zء-ي ]*$/).then(() => true).catch(() => (setErrors((s) => ({ ...s, first_name: 'first_name_should_have_only_alphabets' })))),
        await RegexMatch(inputs.last_name || '', /^[a-zA-Zء-ي ]*$/).then(() => true).catch(() => (setErrors((s) => ({ ...s, last_name: 'last_name_should_have_only_alphabets' })))),
        await RegexMatch(inputs.email || '', /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/).then(() => true).catch(() => (setErrors((s) => ({ ...s, email: 'invalid_email_format' })))),
        await RegexMatch(inputs.phone_number || '', /^[0-9]{9}$/).then(() => true).catch(() => (setErrors((s) => ({ ...s, phone_number: 'invalid_phone_number' })))),
        await RegexMatch(inputs.first_name || '', /^$/).then(() => (setErrors((s) => ({ ...s, first_name: 'please_enter_firstname' })))).catch(() => true),
        await RegexMatch(inputs.last_name || '', /^$/).then(() => (setErrors((s) => ({ ...s, last_name: 'please_enter_last_name' })))).catch(() => true),
        await RegexMatch(inputs.email || '', /^$/).then(() => (setErrors((s) => ({ ...s, email: 'please_enter_email' })))).catch(() => true),
        await RegexMatch(inputs.phone_number || '', /^$/).then(() => (setErrors((s) => ({ ...s, phone_number: 'please_enter_phone_number' })))).catch(() => true),
        inputs.emirates_id ? await RegexMatch(inputs.emirates_id || '', /^[0-9]{15}$/).then(() => true).catch(() => (setErrors((s) => ({ ...s, emirates_id: 'please_enter_valid_emirates_id' })))) : true,
        // await checkBlankArray(inputs.emirates_id_proof || []).then(() => true).catch((e) => setErrors((s) => ({ ...s, emirates_id_proof: 'please_add_emirates_id_proof' }))),
    ]).then((e) => {
        if (e.some(item => item !== true)) return false
        else return true
    })
}

export const onNextButtonValidation = async (inputs, setErrors) => {
    return Promise.all([
        await RegexMatch(inputs.entity || '', /^[a-zA-Z0-9ء-ي .,&'"'’“”‘’]{1,150}$/).then(() => true).catch((err) => (setErrors((s) => ({ ...s, entity: 'acceptable_format_is_alphabets_and_numbers_only' })))),
        await RegexMatch(inputs.reported_elsewhere || '', /^[a-zA-Z]+$/).then(() => true).catch((err) => (setErrors((s) => ({ ...s, reported_elsewhere: err })))),
        await RegexMatch(inputs.incident_type || '', /^$/).then(() => (setErrors((s) => ({ ...s, incident_type: 'please_select_incident_type' })))).catch(() => true),
        await RegexMatch(inputs.entity || '', /^$/).then(() => (setErrors((s) => ({ ...s, entity: 'please_enter_entity' })))).catch(() => true),
        await RegexMatch(inputs.reported_elsewhere || '', /^$/).then(() => (setErrors((s) => ({ ...s, reported_elsewhere: 'please_choose_the_above_field' })))).catch(() => true),
        await RegexMatch(inputs.description || '', /^[a-zA-Z0-9ء-ي .؟،,-:!"?()''’“”‘’\n]+$/).then(() => true).catch(() => (setErrors((s) => ({ ...s, description: `Please enter only alphanumeric characters, spaces, and the following special characters  a-zA-Z0-9ء-ي .؟،,-:!"?()''’“”‘’` })))),
        await MinCharLength(inputs.description || '', 8).then(() => true).catch((err) => (setErrors((s) => ({ ...s, description: err })))),
        await RegexMatch(inputs.description || '', /^$/).then(() => (setErrors((s) => ({ ...s, description: 'please_enter_description' })))).catch(() => true),
        // await RegexMatch(inputs.date || '', /^$/).then(() => (setErrors((s) => ({ ...s, date: 'please_select_date_of_incident' })))).catch(() => true),
        await SupportedFilesCheck(inputs.files || [], ['video/mp4', 'image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'video/mov', "video/quicktime"]).then(e => true).catch(e => setErrors(s => ({ ...s, files: e.message }))),
        await sizeCalculation(inputs.files || [], 100).then(() => true).catch(e => setErrors((s) => ({ ...s, files: e })))
    ]).then((e) => {
        if (e.some(item => item !== true)) return false
        else return true
    })
}

export const fileUploadValidation = async (inputs, setErrors) => {
    return Promise.all([
        await SupportedFilesCheck(inputs.files || [], ['video/mp4', 'image/jpeg', 'image/png', 'image/jpg', 'application/pdf', 'video/mov', "video/quicktime"]).then(e => true).catch(e => setErrors(e.message)),
        await sizeCalculation(inputs.files || [], 100).then(() => true).catch(e => setErrors(e))
    ]).then((e) => {
        if (e.some(item => item !== true)) return false
        else return true
    })
}

